import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  LinearProgress,
  Divider,
  Sheet
} from '@mui/joy';

const PaymentStatus = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { userName, orderId, status, timestamp, amount, currencySymbol } = state || {};

  const [secondsLeft, setSecondsLeft] = useState(600); // 10 minutes

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          navigate('/user-dashboard');
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e0f7fa, #e1bee7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 3,
        transition: 'all 0.5s ease-in-out',
      }}
    >
      <Card
        variant="soft"
        sx={{
          maxWidth: 500,
          width: '100%',
          borderRadius: 'lg',
          boxShadow: 'lg',
          backgroundColor: '#fff',
          animation: 'fadeIn 0.8s ease-in-out',
        }}
      >
        <CardContent>
          <Typography level="h2" textAlign="center" sx={{ mb: 2 }}>
            {status === 'succeeded' ? '🎉 Payment Successful' : '⏳ Payment Status'}
          </Typography>

          <Divider />

          <Sheet
            sx={{
              mt: 2,
              mb: 2,
              p: 2,
              borderRadius: 'md',
              backgroundColor: '#f3e5f5',
              transition: 'background 0.5s ease',
            }}
          >
            <Typography level="body-md" sx={{ mb: 1 }}>
              <strong>User Name:</strong> {userName}
            </Typography>
            <Typography level="body-md" sx={{ mb: 1 }}>
              <strong>Order ID:</strong> {orderId}
            </Typography>
            <Typography level="body-md" sx={{ mb: 1 }}>
              <strong>Status:</strong>{' '}
              <Typography
                level="body-md"
                color={status === 'succeeded' ? 'success' : 'warning'}
                sx={{ fontWeight: 'bold' }}
              >
                {status}
              </Typography>
            </Typography>
            <Typography level="body-md" sx={{ mb: 1 }}>
              <strong>Amount:</strong> {currencySymbol}{amount}
            </Typography>
            <Typography level="body-md">
              <strong>Payment Time:</strong>{' '}
              {new Date(timestamp).toLocaleString()}
            </Typography>
          </Sheet>

          <Divider />

          <Box sx={{ mt: 2, textAlign: 'center' }}>
  <Typography level="body-md" sx={{ mb: 1 }}>
    Redirecting to your dashboard in:
  </Typography>
  <Typography
    level="h3"
    color="primary"
    sx={{ fontWeight: 'bold', fontVariantNumeric: 'tabular-nums' }}
  >
    {formatTime(secondsLeft)}
  </Typography>
  <LinearProgress
    variant="soft"
    color="primary"
    determinate
    value={((600 - secondsLeft) / 600) * 100}
    sx={{ mt: 1, mb: 2 }}
  />

  <button
    onClick={() => navigate('/user-dashboard')}
    style={{
      backgroundColor: '#6200ea',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '10px 20px',
      fontSize: '14px',
      cursor: 'pointer',
      transition: 'background 0.3s ease',
    }}
    onMouseOver={(e) => (e.target.style.backgroundColor = '#512da8')}
    onMouseOut={(e) => (e.target.style.backgroundColor = '#6200ea')}
  >
    Go to Dashboard Now
  </button>
</Box>

        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentStatus;
